'use strict';

/**
 * Updates the product attribute in the Product Detail Page
 *
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {string} attrValue - Attribute value for the passed attrbute id
 * @param {string} className - Attribute class name to be changed
 */
function updateAttribute($productContainer, attrValue, className) {
    var $container = $productContainer.find(className);
    if (attrValue && attrValue.length > 0) {
        $container.find(className + '-value').html(attrValue);
        $container.removeClass('d-none');
    } else {
        $container.find(className + '-value').empty();
        $container.addClass('d-none');
    }
}

/**
 * Updates the lens name and frame color attributes related to Spy Optic in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAttributes(response, $productContainer) {
    $productContainer.find('.lens-attributes').removeClass('d-none');
    $productContainer.find('.product-name').html(response.product.productName);
    updateAttribute($productContainer, response.product.frameColor, '.frame-color');
    updateAttribute($productContainer, response.product.lensName, '.lens-name');

    if (response.product.RxUrl) {
        $productContainer.find('.rx-url').removeClass('d-none').attr('data-has-rx-url', true);
        $productContainer.find('.rx-url-link').attr('href', response.product.RxUrl);
    } else {
        $productContainer.find('.rx-url').addClass('d-none').attr('data-has-rx-url', false);
    }
}

module.exports = function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        updateAttributes(response.data, response.container);
    });
};
